import {Tooltip} from 'antd';
import React from 'react';
import utils from '../../../utils';
import fetch from '../../fetch';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + '',
            disabled: d.disabled
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/collect/analysis/studentQuery?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            const expandColumn = response.payload.meta.extParams.expandColumn;
            const columns = [
                {   
                    key: '$index', 
                    label: '序号',
                    width: 60
                },
                {
                    key: 'objectName', 
                    label: '对象名称'
                }
            ]
            for (let i = 0; i < expandColumn; i ++) {
                columns.push({
                    key: 'targetName' + i, 
                    label: '指标名称' + (i + 1),
                    render: (data) => {
                        return <Tooltip title={data}>
                            {data}
                        </Tooltip>
                    }
                })
                columns.push({
                    key: 'score' + i, 
                    label: '分数' + (i + 1)
                })
                columns.push({
                    key: 'time' + i, 
                    label: '次数' + (i + 1)
                })
            }
            columns.push({
                key: 'avgScore',
                label: '平均分'
            })
            columns.push({
                key: 'termName',
                label: '学期'
            })
            return {
                headers : utils.columns(columns),
                data: response.payload.data,
            }
        }
    }).then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data || []).length ? '' : '暂无数据...'
        }))
    )
}

const config = (keywords) => {
    return fetch.post('survey/collect/analysis/studentConfig', keywords)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const queryConfig = () => {
    return fetch.get('survey/collect/analysis/query/studentConfig')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}


const collect = () => {
    return fetch.get('survey/collect/analysis/studentCollect')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const queryTargetTree = () => {
    return fetch.get('eval/target/queryAll')
    .then(response => response.payload.data)
    .then(res => {
        const data = res.map(r => {
            return {
                id: r.id,
                pid: r.pid,
                label: r.name,
                disabled: r.type === 1
            }
        })
        return transform(utils.tree(data));
    })
}

export default {
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    querySearch,
    config,
    queryTargetTree,
    queryConfig,
    collect
}